<div class="p-3 border rounded-3 bg-light shadow">
  <div class="mb-3 fs-6 fw-medium">
    <i class="fa-regular fa-clock"></i>
    Оставащо време
  </div>
  <div class="mb-3 row g-3">
    @if (remainingDays !== 0) {
      <div class="col">
        <div class="py-2 rounded-3 shadow bg-white text-center">
          <h5 class="mb-0">{{ remainingDays }}</h5>
          <small class="text-muted">дни</small>
        </div>
      </div>
    }
    <div class="col">
      <div class="py-2 rounded-3 shadow bg-white text-center">
        <h5 class="mb-0"
            [class.text-muted]="remainingDays === 0 && remainingHours === 0">
          {{ remainingHours }}
        </h5>
        <small class="text-muted">часа</small>
      </div>
    </div>
    <div class="col">
      <div class="py-2 rounded-3 shadow bg-white text-center">
        <h5 class="mb-0"
            [class.text-muted]="remainingDays === 0 && remainingHours === 0 && remainingMinutes === 0">
          {{ remainingMinutes }}
        </h5>
        <small class="text-muted">минути</small>
      </div>
    </div>
    @if (remainingDays === 0) {
      <div class="col">
        <div class="py-2 rounded-3 shadow bg-white text-center">
          <h5 class="mb-0"
              [class.text-muted]="remainingDays === 0 && remainingHours === 0 && remainingMinutes === 0 && remainingSeconds === 0"
              [class.text-danger]="remainingDays === 0 && remainingHours === 0 && remainingMinutes === 0 && remainingSeconds !== 0">
            {{ remainingSeconds }}
          </h5>
          <small class="text-muted">секунди</small>
        </div>
      </div>
    }
  </div>
  @if (!!adDetails.adBidExtensionTimeOptionId) {
    <div class="small d-flex gap-1">
      <span>
        <i class="text-warning fa-solid fa-triangle-exclamation"></i>
        Удължаване на аукциона с <strong>{{ adDetails.adBidExtensionTimeOptionName }}</strong>
      </span>
      <button
        type="button"
        aria-label="Научете повече"
        (click)="showBidExtensionTimeInfo()"
        class="p-0 btn btn-link btn-sm text-primary-emphasis">
        <i class="fa-regular fa-circle-question" aria-hidden="true"></i>
      </button>
    </div>
  }
  <hr>
  <div class="d-flex justify-content-between">
    <button class="p-0 btn btn-link text-decoration-none"
            [disabled]="adDetails.likeCount <= 0"
            (click)="onOpenAdLikesModal()">
      Харесвания: {{ adDetails.likeCount }}
    </button>
    <button class="p-0 btn btn-link text-decoration-none"
            [disabled]="adDetails.visitCount <= 0"
            (click)="onOpenAdVisitsModal()">
      Посещения: {{ adDetails.visitCount }}
    </button>
  </div>
</div>
